import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'meta'

  static get fields () {
    return {
      id: new UUID(),
      key: new STRING(),
      value: new STRING(),
      resource: new STRING(),
      resource_uuid: new UUID(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
